module.exports = __webpack_public_path__ + "static/WelcomeToElk5-f5745fb32ca46051ce52bf466b80f33d.webp";